import { combineReducers } from 'redux';
import aesReduxConstants from '../constants';

const mapSetReducer = function() {
  const constants = aesReduxConstants.MAP_SET;

  const isType = function(entity, type) {
    return getType(entity) === type;
  };

  var getType = function(entity) {
    if (entity.clientId) {
      if (entity.userId) {
        return 'user';
      }
      if (entity.editable) {
        return 'client';
      }
      return 'global';
    }
  };

  const getIdsByType = function(entities, type) {
    const filtered = entities.filter(entity => isType(entity, type));

    return filtered.map(entity => entity.id);
  };


  // Reducers
  const createList = function(type) {
    const defaultState = [];

    return function(state, action) {
      if (state === undefined) {
        state = defaultState;
      }

      switch (action.type) {
        case `${constants.GET_ALL}_SUCCESS`:
          return getIdsByType(action.payload, type);
        default:
          return state;
      }
    };
  };


  const fetchingReducer = function(state, action) {
    if (state === undefined) state = false;

    switch (action.type) {
      case `${constants.GET}_REQUEST`:
      case `${constants.GET_ALL}_REQUEST`:
        return true;

      case `${constants.GET}_FAILURE`:
      case `${constants.GET}_SUCCESS`:
        return false;

      case `${constants.GET_ALL}_FAILURE`:
      case `${constants.GET_ALL}_SUCCESS`:
        return false;

      default:
        return state;
    }
  };

  const byIdReducer = function(state, action) {
    if (state === undefined) state = {};

    switch (action.type) {
      case `${constants.GET_ALL}_SUCCESS`:
        return Object.assign({}, state, normalizeByKey(action.payload, 'id'));

      case `${constants.GET}_SUCCESS`:
      case `${constants.UPDATE}_SUCCESS`:
        var obj = {};
        obj[action.payload.id] = action.payload;

        return Object.assign({}, state, obj);

      default:
        return state;
    }
  };

  const idsByOwner = combineReducers({
    client: createList('client'),
    global: createList('global'),
    user: createList('user'),
  });

  return combineReducers({
    isFetching: fetchingReducer,
    byId: byIdReducer,
    idsByOwner,
  });
};

export default mapSetReducer();
